module.exports = __webpack_public_path__ + "static/media/lambda_vs_university.b8234e31.mp4";